import { ChangeCartDeliveryModeResult } from '../../../graphql/cart/changeCartDeliveryMode';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartDeliveryModeRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
}

export const apiCartChangeCartDeliveryModeRequestedType =
  'api/cart/changeCartDeliveryMode--requested';
export const apiCartChangeCartDeliveryModeRequested =
  createAction<ApiCartChangeCartDeliveryModeRequestedPayload>(
    apiCartChangeCartDeliveryModeRequestedType
  );
export type ApiCartChangeCartDeliveryModeRequestedAction = ReturnType<
  typeof apiCartChangeCartDeliveryModeRequested
>;

export interface ApiCartChangeCartDeliveryModeSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartDeliveryModeResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartDeliveryModeSucceededType =
  'api/cart/changeCartDeliveryMode--succeeded';
export const apiCartChangeCartDeliveryModeSucceeded =
  createAction<ApiCartChangeCartDeliveryModeSucceededPayload>(
    apiCartChangeCartDeliveryModeSucceededType
  );
export type ApiCartChangeCartDeliveryModeSucceededAction = ReturnType<
  typeof apiCartChangeCartDeliveryModeSucceeded
>;

export interface ApiCartChangeCartDeliveryModeFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartDeliveryModeFailedType = 'api/cart/changeCartDeliveryMode--failed';
export const apiCartChangeCartDeliveryModeFailed =
  createAction<ApiCartChangeCartDeliveryModeFailedPayload>(apiCartChangeCartDeliveryModeFailedType);
export type ApiCartChangeCartDeliveryModeFailedAction = ReturnType<
  typeof apiCartChangeCartDeliveryModeFailed
>;
